import makeRequest from './client';

export const getCurationStatus = (source: string, task: string) => {
  return makeRequest(`/${source}/curation_status/${task}`, 'GET');
};

export const updateCurationStatus = (source: string, task: string, newStatus: boolean) => {
  return makeRequest(`/${source}/curation_status/${task}`, 'PUT', { new_status: newStatus });
};
